import { CALL_API } from '../../middleware/api';

/**
 * PROJECT添加
 */
export const PROJECT_ADD_REQUEST = 'PROJECT_ADD_REQUEST';
export const PROJECT_ADD_SUCCESS = 'PROJECT_ADD_SUCCESS';
export const PROJECT_ADD_FAILURE = 'PROJECT_ADD_FAILURE';

/**
 * PROJECT更新
 */
export const PROJECT_UPDATE_REQUEST = 'PROJECT_UPDATE_REQUEST';
export const PROJECT_UPDATE_SUCCESS = 'PROJECT_UPDATE_SUCCESS';
export const PROJECT_UPDATE_FAILURE = 'PROJECT_UPDATE_FAILURE';

/**
 * PROJECT更新
 */
export const PROJECT_LIST_REQUEST = 'PROJECT_LIST_REQUEST';
export const PROJECT_LIST_SUCCESS = 'PROJECT_LIST_SUCCESS';
export const PROJECT_LIST_FAILURE = 'PROJECT_LIST_FAILURE';

/**
 * PROJECT详情
 */
export const PROJECT_DETAIL_REQUEST = 'PROJECT_DETAIL_REQUEST';
export const PROJECT_DETAIL_SUCCESS = 'PROJECT_DETAIL_SUCCESS';
export const PROJECT_DETAIL_FAILURE = 'PROJECT_DETAIL_FAILURE';

/**
 * PROJECT设置项目财务
 */
export const PROJECT_SET_FINANCIAL_REQUEST = 'PROJECT_SET_FINANCIAL_REQUEST';
export const PROJECT_SET_FINANCIAL_SUCCESS = 'PROJECT_SET_FINANCIAL_SUCCESS';
export const PROJECT_SET_FINANCIAL_FAILURE = 'PROJECT_SET_FINANCIAL_FAILURE';

export function addProject(params) {
  return {
    [CALL_API]: {
      types: [PROJECT_ADD_REQUEST, PROJECT_ADD_SUCCESS, PROJECT_ADD_FAILURE],
      endpoint: 'project/project/add',
      methods: 'POST',
      params
    }
  }
}

export function updateProject(params) {
  return {
    [CALL_API]: {
      types: [PROJECT_UPDATE_REQUEST, PROJECT_UPDATE_SUCCESS, PROJECT_UPDATE_FAILURE],
      endpoint: 'project/project/update',
      methods: 'POST',
      params
    }
  }
}

export function getProject(params) {
  return {
    [CALL_API]: {
      types: [PROJECT_LIST_REQUEST, PROJECT_LIST_SUCCESS, PROJECT_LIST_FAILURE],
      endpoint: 'project/project/all',
      methods: 'GET',
      params
    }
  }
}

export function getProjectDetail(params) {
  return {
    [CALL_API]: {
      types: [PROJECT_DETAIL_REQUEST, PROJECT_DETAIL_SUCCESS, PROJECT_DETAIL_FAILURE],
      endpoint: 'project/project/detail',
      methods: 'GET',
      params
    }
  }
}

export function setProjectFinancial(params) {
	return {
		[CALL_API]: {
			types: [PROJECT_SET_FINANCIAL_REQUEST, PROJECT_SET_FINANCIAL_SUCCESS, PROJECT_SET_FINANCIAL_FAILURE],
			endpoint: 'project/project/set-financial',
			methods: 'POST',
			params
		}
	}
}



// WEBPACK FOOTER //
// ./src/action/project_manager/project.js